<template>
    <div>
        <app-card
            headerIcon="wifi_off"
            :heading="$t('lang.offline_devices')"
            colClasses=""
            customClasses="mb-0"
            :fullScreen="true"
            :reloadable="true"
            :closeable="true"
            :fullBlock="true"
            :footer="true"
            :reload="reload"
            :count="page.total_records"
        >
            <invoice></invoice>
            <bc-pagination
                class="small-pagination"
                slot="footer"
                :page="page"
                :params="axiosParams"
                sendCommit="mutateUpdateDashboardOfflineDevices"
            ></bc-pagination>
            <v-spacer slot="footer"></v-spacer>
            <v-btn
                slot="footer"
                color="primary"
                @click="$router.push({ name: 'devices', query: { connection_status: 'offline', page_num: dashboard_offline_devices_page_num } })"
                small
                >{{ $t("lang.view_all") }}</v-btn
            >

            <v-btn slot="header" icon small @click="refreshOfflineDevices"><v-icon>refresh</v-icon></v-btn>
        </app-card>
    </div>
</template>
<script>
import invoice from "App_components/Widgets/OfflineDevices.vue";
import { mapActions, mapState } from "vuex";
export default {
    components: {
        invoice,
    },
    data() {
        return {
            name: "recent_data_sessions",
            reload: false,
            filter: {
                search: "",
                status: "active",
                company_id: null,
                device_type_id: null,
                tags: [],
                page_size: 0,
                page_num: 0,
                connection_status: "",
            },
        };
    },
    computed: {
        ...mapState({
            devices: (state) => state.devices.devices,
            offline_devices: (state) => state.devices.offline_devices,
            page: (state) => state.devices.offline_devices_page,
            default_filter: (state) => state.devices.devices_filter,
            dashboard_offline_devices_page_num: (state) => state.devices.dashboard_offline_devices_page_num,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchDevices"]),
        async refreshOfflineDevices() {
            this.reload = true;
            this.$store.commit("mutate", {
                property: "offline_devices",
                with: [],
            });
            this.fetchDevices({
                body: {
                    connection_status: "offline",
                    page_num: this.dashboard_offline_devices_page_num,
                    tags: this.current_user.tags_filter !== null ? [...this.current_user.tags_filter.split(",")] : [],
                },
            }).then((data) => {
                this.$store.commit("mutate", {
                    property: "offline_devices",
                    with: [...this.devices],
                });
                this.reload = false;
            });
        },
    },
};
</script>
